import React from 'react'

import Stack from '@mui/material/Stack'

interface CardButtonSectionProps {
  button: React.ReactNode
  withFullWidthImage?: boolean
}

export const CardButtonSection: React.FC<CardButtonSectionProps> = ({
  button,
  withFullWidthImage,
}) => {
  return (
    <Stack
      sx={{
        justifyContent: 'flex-end',
        flex: '1 0 auto',
        mt: 8,
        ...(withFullWidthImage && {
          // TODO: Refactor out the usage of the withFullWidthImage prop being drilled down in multiple components
          px: 16,
          pb: 16,
        }),
      }}
    >
      {button}
    </Stack>
  )
}
